import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Documentaire() {
  const [email, setEmail] = useState('');
  const [inscrit, setInscrit] = useState(false);
  const [errInscr, setErrInscr] = useState('');

  const handleInscription = async () => {
    const e = email.trim();
    if (!e) { setErrInscr('Entrez votre adresse email.'); return; }
    setErrInscr('');
    try {
      const r = await fetch('/api/subscribers', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: e, source: 'documentaire' }) });
      if (r.ok) setInscrit(true);
      else { const d = await r.json().catch(() => ({})); setErrInscr(d.message || 'Adresse invalide.'); }
    } catch (err) { setErrInscr('Connexion impossible. Réessayez.'); }
  };

  const S = { maxWidth: 1100, margin: '0 auto' };

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>

      {/* HERO */}
      <div style={{ background: '#1a0808', padding: '72px 40px 64px', textAlign: 'center' }}>
        <div style={{ fontSize: 12, letterSpacing: '0.2em', color: '#e8a0a0', fontWeight: 700, marginBottom: 18 }}>LE DOCUMENTAIRE</div>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 38, color: '#fff', fontWeight: 400, lineHeight: 1.5, margin: '0 auto 20px', maxWidth: 700 }}>
          Un film pour <em style={{ color: '#e8a0a0', fontStyle: 'italic' }}>rétablir la vérité</em><br />et honorer l'héritage
        </h1>
        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.65)', lineHeight: 1.9, maxWidth: 580, margin: '0 auto 32px' }}>
          Un projet personnel — un documentaire vu par les fans, raconté par les fans, pour tous ceux qui ont toujours su qui était vraiment Michael Jackson.
        </p>
        <div style={{ display: 'inline-block', padding: '8px 24px', borderRadius: 20, border: '1.5px solid #e8a0a0', color: '#e8a0a0', fontSize: 12, fontWeight: 700, letterSpacing: '0.08em' }}>
          PROJET EN COURS DE CONCEPTION
        </div>
      </div>

      {/* POURQUOI */}
      <div style={{ padding: '64px 48px', borderBottom: '2px solid #c49090' }}>
        <div style={S}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 10 }}>POURQUOI CE DOCUMENTAIRE</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 22 }}>Ce que les autres n'ont pas dit</div>
          <p style={{ fontSize: 15, color: '#4a3030', lineHeight: 2, marginBottom: 32 }}>
            Depuis des années, les documentaires sur Michael Jackson ont choisi le sensationnel au détriment de la vérité. Ils ont amplifié les accusations, ignoré les faits, et effacé l'immense héritage humanitaire et artistique d'un homme qui a consacré sa vie à l'amour et à la paix. Il est temps qu'un autre récit existe — celui des gens qui l'ont connu, aimé, et compris.
          </p>
          <div style={{ background: '#fff', borderLeft: '4px solid #8b1a2a', borderRadius: '0 12px 12px 0', padding: '26px 32px', border: '1.5px solid #e8d5d0', borderLeftWidth: 4, borderLeftColor: '#8b1a2a' }}>
            <p style={{ fontFamily: 'Georgia,serif', fontSize: 17, color: '#3a2020', fontStyle: 'italic', lineHeight: 1.85 }}>
              If you enter this world knowing you are loved and you leave this world knowing the same, then everything that happens in between can be dealt with.
            </p>
            <cite style={{ fontSize: 12, color: '#8b1a2a', fontWeight: 700, letterSpacing: '0.08em', display: 'block', marginTop: 12 }}>— MICHAEL JACKSON</cite>
          </div>
        </div>
      </div>

      {/* CE QUE CE DOCU SERA */}
      <div style={{ padding: '64px 48px', borderBottom: '2px solid #c49090' }}>
        <div style={S}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 10 }}>CE QUE CE DOCUMENTAIRE SERA</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 28 }}>Une vision juste et glorieuse</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', gap: 24 }}>
            {[
              { icon: '🎨', titre: "L'artiste complet", desc: "Danseur, compositeur, producteur, visionnaire — le génie artistique dans toute son ampleur." },
              { icon: '🌍', titre: "L'humanitaire oublié", desc: "39 associations caritatives, Heal the World Foundation, des millions de vies touchées." },
              { icon: '💬', titre: "La voix des fans", desc: "Des témoignages du monde entier — rencontres, concerts, moments qui ont changé des vies." },
              { icon: '🔍', titre: "Les faits, rien que les faits", desc: "2005 : 14 chefs d'accusation, 14 acquittements." },
            ].map(c => (
              <div key={c.titre} style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderLeft: '4px solid #8b1a2a', borderRadius: '0 12px 12px 0', padding: '26px 22px' }}>
                <div style={{ fontSize: 32, marginBottom: 14 }}>{c.icon}</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1010', marginBottom: 10 }}>{c.titre}</div>
                <div style={{ fontSize: 13, color: '#6a5050', lineHeight: 1.8 }}>{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CE QUE CE DOCU NE SERA PAS */}
      <div style={{ padding: '64px 48px', borderBottom: '2px solid #c49090', background: '#fff8f8' }}>
        <div style={S}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 10 }}>CE QUE CE DOCUMENTAIRE NE SERA PAS</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 28 }}>Une ligne rouge claire</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))', gap: 24 }}>
            {[
              { titre: "Pas un doc à charge", desc: "Aucune place pour les accusations non prouvées ni le voyeurisme médiatique." },
              { titre: "Pas du sensationnel", desc: "Pas de titres racoleurs, pas de révélations choc — seulement la vérité documentée." },
              { titre: "Pas une hagiographie naïve", desc: "Un portrait honnête, humain, sans mythification excessive — un être humain exceptionnel." },
              { titre: "Pas fait par des étrangers", desc: "Ce film sera fait par quelqu'un qui l'aime et le comprend vraiment." },
            ].map(c => (
              <div key={c.titre} style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderLeft: '4px solid #c49090', borderRadius: '0 12px 12px 0', padding: '26px 22px' }}>
                <div style={{ fontSize: 32, marginBottom: 14 }}>🚫</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1a1010', marginBottom: 10 }}>{c.titre}</div>
                <div style={{ fontSize: 13, color: '#6a5050', lineHeight: 1.8 }}>{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TIMELINE */}
      <div style={{ padding: '64px 48px', borderBottom: '2px solid #c49090' }}>
        <div style={S}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 10 }}>TIMELINE DU PROJET</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 32 }}>Un chemin qui se construit</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {[
              { date: "AUJOURD'HUI — 2026", titre: "Collecte des témoignages", desc: "Ce site est la première brique — rassembler les voix des fans du monde entier.", actif: true },
              { date: "2027–2028", titre: "Recherche et documentation", desc: "Archives, interviews, sources primaires — construire le socle factuel du documentaire.", actif: false },
              { date: "2029–2030", titre: "Production", desc: "Tournage, interviews filmées, montage — donner vie au projet.", actif: false },
              { date: "2030+", titre: "Diffusion", desc: "Festivals, plateformes, projections — faire entendre cette vérité au monde.", actif: false },
            ].map((item, i, arr) => (
              <div key={item.date} style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 48, flexShrink: 0 }}>
                  <div style={{ width: 18, height: 18, borderRadius: '50%', background: item.actif ? '#8b1a2a' : '#c49090', border: '3px solid #fafaf8', outline: `2px solid ${item.actif ? '#8b1a2a' : '#c49090'}`, flexShrink: 0, marginTop: 2 }}></div>
                  {i < arr.length - 1 && <div style={{ width: 2, flex: 1, background: '#e8d5d0', minHeight: 48 }}></div>}
                </div>
                <div style={{ paddingBottom: i < arr.length - 1 ? 40 : 0, flex: 1 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#8b1a2a', letterSpacing: '0.08em', marginBottom: 6 }}>{item.date}</div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#1a1010', marginBottom: 8 }}>{item.titre}</div>
                  <div style={{ fontSize: 14, color: '#6a5050', lineHeight: 1.8 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* PARTICIPER */}
      <div style={{ padding: '64px 48px', borderBottom: '2px solid #c49090' }}>
        <div style={S}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 10 }}>COMMENT PARTICIPER</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 16 }}>Votre histoire compte</div>
          <p style={{ fontSize: 15, color: '#4a3030', lineHeight: 2, marginBottom: 32 }}>
            Vous avez rencontré Michael ? Assisté à un concert ? Une anecdote, une photo, une vidéo ? Votre témoignage pourrait faire partie du documentaire.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
            {[
              { icon: '🎤', titre: 'Témoignage écrit', desc: 'Racontez votre histoire via la page Témoigner', link: '/temoigner' },
              { icon: '📸', titre: 'Archives personnelles', desc: 'Photos ou vidéos personnelles avec Michael ou ses concerts', link: '/temoigner' },
              { icon: '📧', titre: 'Contact direct', desc: 'Pour proposer une interview filmée ou un partenariat', link: 'mailto:contact@mjkop.com' },
            ].map(c => {
              const cardStyle = { display: 'block', background: '#fff', border: '1.5px solid #e8d5d0', borderRadius: 14, padding: '32px 24px', textAlign: 'center', textDecoration: 'none', cursor: 'pointer', transition: 'border-color 0.15s, box-shadow 0.15s, transform 0.15s' };
              const enter = e => { e.currentTarget.style.borderColor = '#8b1a2a'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(139,26,42,0.12)'; e.currentTarget.style.transform = 'translateY(-2px)'; };
              const leave = e => { e.currentTarget.style.borderColor = '#e8d5d0'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; };
              const inner = (<><div style={{ fontSize: 36, marginBottom: 14 }}>{c.icon}</div><div style={{ fontSize: 15, fontWeight: 700, color: '#1a1010', marginBottom: 10 }}>{c.titre}</div><div style={{ fontSize: 13, color: '#6a5050', lineHeight: 1.7 }}>{c.desc}</div></>);
              return c.link.charAt(0) === '/'
                ? <Link key={c.titre} to={c.link} style={cardStyle} onMouseEnter={enter} onMouseLeave={leave}>{inner}</Link>
                : <a key={c.titre} href={c.link} style={cardStyle} onMouseEnter={enter} onMouseLeave={leave}>{inner}</a>;
            })}
          </div>
        </div>
      </div>

      {/* INSCRIPTION */}
      <div style={{ background: '#1a0808', padding: '72px 48px' }}>
        <div style={{ maxWidth: 580, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#e8a0a0', fontWeight: 700, marginBottom: 14 }}>RESTER INFORMÉ</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 26, color: '#fff', marginBottom: 14 }}>Suivre l'avancement du projet</div>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.9, marginBottom: 32 }}>
            Laissez votre email pour être prévenu(e) des avancées du documentaire, des appels à témoins et de la sortie du film.
          </p>
          {inscrit ? (
            <div style={{ background: 'rgba(232,160,160,0.15)', border: '1.5px solid #e8a0a0', borderRadius: 10, padding: '20px 28px', color: '#e8a0a0', fontSize: 15, fontFamily: 'Georgia,serif' }}>
              ✓ Vous êtes inscrit(e) — merci pour votre soutien !
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', gap: 10, maxWidth: 480, margin: '0 auto' }}>
                <input
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleInscription()}
                  placeholder="Votre adresse email"
                  style={{ flex: 1, padding: '13px 18px', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: 14, outline: 'none' }}
                />
                <button onClick={handleInscription} style={{ padding: '13px 24px', borderRadius: 8, border: 'none', background: '#8b1a2a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  Je suis le projet
                </button>
              </div>
              {errInscr && <p style={{ fontSize: 12, color: '#e8a0a0', marginTop: 12 }}>{errInscr}</p>}
              <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', marginTop: 14 }}>Aucun spam. Désabonnement possible à tout moment.</p>
            </>
          )}
        </div>
      </div>

    </div>
  );
}
